import { render, staticRenderFns } from "./UploadProductsMaterial.vue?vue&type=template&id=6ec803ba&scoped=true&"
import script from "./UploadProductsMaterial.vue?vue&type=script&lang=js&"
export * from "./UploadProductsMaterial.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec803ba",
  null
  
)

export default component.exports